export default __webpack_public_path__ + "static/media/FillHome.1ac5a1a9.svg";